let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7p3Ec")).then(() => parcelRequire('9wqJG'));